import * as React from 'react';
import { HELPER_TOOLTIP_MAPPING } from '../../../mapping/helperTooltip';
import QuestionIcon from '../../../assets/SVG/QuestionIcon';
import classNames = require('classnames');

interface HelperTooltipsProps {
    children: React.ReactNode;
    icon?: boolean;
    pathname?: string;
    helperText?: string;
    placement: string;
    textSize: string;
}

const HelperTooltip: React.FC<HelperTooltipsProps> = (
    props: HelperTooltipsProps
) => {
    let timeout;
    const [active, setActive] = React.useState(false);
    const [isLarge, setIsLarge] = React.useState(false);
    const tooltipRef = React.useRef<HTMLDivElement>();
    const initialRenderRef = React.useRef<boolean>(true);
    const content = props.helperText
        ? props.helperText
        : HELPER_TOOLTIP_MAPPING[props.pathname];

    React.useEffect(() => {
        if (tooltipRef.current && initialRenderRef.current) {
            const numberOfLines = calculateLines();
            initialRenderRef.current = false;
            numberOfLines > 5 && setIsLarge(true);
        }
    }, [active]);
    const showTip = () => {
        timeout = setTimeout(() => {
            setActive(true);
        }, 400);
    };

    const hideTip = () => {
        clearInterval(timeout);
        setActive(false);
    };
    // TBD if we want to have different sizes according to the # of lines [SM,MD,LG]
    const calculateLines = () =>
        Math.ceil(
            tooltipRef.current.clientHeight /
                Math.floor(parseFloat(tooltipRef.current.style.fontSize) * 1.5)
        );
    const renderContent = () => {
        return (
            active && (
                <div
                    className={classNames(
                        `helper-tooltip helper-tooltip-${props.placement}${
                            props.icon ? '-icon' : ''
                        }`,
                        { longContent: isLarge }
                    )}
                    style={{
                        fontSize: props.textSize === 'large' ? '16px' : '14px'
                    }}
                    ref={tooltipRef}
                >
                    {content}
                </div>
            )
        );
    };
    if (content) {
        return props.icon ? (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {props.children}
                <div
                    className="helper-tooltip-wrapper"
                    style={{
                        marginLeft: '8px'
                    }}
                    onMouseEnter={showTip}
                    onMouseLeave={hideTip}
                >
                    <QuestionIcon />
                    {content && renderContent()}
                </div>
            </div>
        ) : (
            <div
                className="helper-tooltip-wrapper"
                onMouseEnter={showTip}
                onMouseLeave={hideTip}
            >
                {props.children}
                {content && renderContent()}
            </div>
        );
    } else {
        return <>{props.children}</>;
    }
};

export default HelperTooltip;
